// extracted by mini-css-extract-plugin
export var address = "footer-module--address--1af68";
export var copyright = "footer-module--copyright--37395";
export var emphasise = "footer-module--emphasise--09e4a";
export var footerNavList = "footer-module--footerNavList--710e7";
export var footerStyle = "footer-module--footerStyle--a5877";
export var socialLink = "footer-module--socialLink--e9495";